<template>
	<div class="card-container">
		<card-gift v-if="type === constant.CARD_GIFT" :class="[`card--${color}`]" :from="from" :to="to" :message="message" :present="present" />
		<card-gift ref="popup" v-if="type === constant.CARD_GIFT" :class="[`card--${color}`]" :from="from" :to="to" :message="message" :present="present" />
		<card-instagram v-if="type === constant.CARD_INSTAGRAM" :class="[`card--${color}`]" :message="message" :image="image" />
		<card-instagram v-if="type === constant.CARD_INSTAGRAM" :class="[`card--${color}`]" :message="message" :image="image"/>
	</div>
</template>

<script>
import * as constant from '@/constants';
import CardGift from './CardGift';
import CardInstagram from './CardInstagram';

export default {
	components: { CardGift, CardInstagram },
	props: {
		from: {
			type: String,
			default: 'Elisabeth Walter',
			required: false,
		},
		to: {
			type: String,
			default: 'Dr. Askin',
			required: false,
		},
		message: {
			type: String,
			default: 'It was not just the medical care, but also the reassuring words and support that helped me to get better. Thanks Dr Askin and everyone at POW.',
			required: true,
		},
		type: {
			type: String,
			default: constant.CARD_GIFT,
			required: true,
		},
		color: {
			type: String,
			default: 'green',
			required: true,
		},
		image: {
			type: String,
			default: '',
			required: false,
		},
		present: {
			type: String,
			default: '',
			required: false,
		},
	},
	computed: {
		constant: () => constant,
	},
	methods: {
		activate () {
			if (this.$refs.popup) {
				this.$refs.popup.activate();
			}
		},
	},
};
</script>

<style lang=less scoped>
	@import (reference) '../assets/less/default.less';

	.card-container { position: relative;
		.card:first-of-type { position: relative; }
		.card:last-of-type { .top-left(0, 0, 10); opacity: 1; }

		@keyframes popup {
			0% { transform: scale(1); transform-origin: center center; }
			10% { transform: scale(1.2); }
			30% { transform: translate(var(--moveX), var(--moveY)) scale(1.2); opacity: 1; }
			68% { transform: translate(var(--moveX), var(--moveY)) scale(2.5); }
			100% { transform: translate(var(--moveX), var(--moveY)) scale(2.5); }
		}

		@keyframes popup-close {
			0% { transform: translate(var(--moveX), var(--moveY)) scale(3); opacity: 1; }
			99.9% { transform: translate(var(--moveX), var(--moveY)) scale(3.5); opacity: 1; }
			100% { transform: translate(var(--moveX), var(--moveY)) scale(3.5); opacity: 0; }
		}

		&.active .card:last-of-type {
			animation: popup var(--openTiming) cubic-bezier(0.4, 0, 0.2, 1) forwards;
			z-index: 20;
			-webkit-backface-visibility: hidden;
		}

		&.close .card:last-of-type {
			animation: popup-close var(--closeTiming) ease-out forwards;
			z-index: 20;
			-webkit-backface-visibility: hidden;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/CardContainer.vue